import React from "react";
import _ from "lodash";
import Modal from "../../../../../components/ModalPopup";
import Button from "../../../../../components/Button";
import FHIRDetails from "../../../../../components/FHIRDetails";
import { defaultAttributeOverridesObject } from "./../Utils";
import styles from "../MultipleAttributeOverride.module.scss";

const MultipleAttributeOverrideModal = (
  selectedRecord,
  primaryRecords,
  attributeOverrides,
  setAttributeOverrides,
  isOpen,
  setIsOpen,
  setConfirmOverridesDialog,
  setRecordOverrideDialogContent,
  setRecordOverride,
  setRecordOverrideDialog,
  isNewQuarantine
) => {
  const handleConfirm = () => {
    setConfirmOverridesDialog(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
    setAttributeOverrides(defaultAttributeOverridesObject);
  };

  if (!_.isEmpty(selectedRecord)) {
    return (
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <div className={styles.multipleAttributeOverrideDetails}>
          <h2 style={{ textAlign: "left" }}>Override Multiple Attributes</h2>
          <br />
          <h3 style={{ textAlign: "left" }}>
            {selectedRecord.original.goldenId +
              " | " +
              selectedRecord.original.source +
              " | " +
              selectedRecord.original.recordId}
          </h3>
          <br />
          {selectedRecord.original.table === "primary" ? (
            <FHIRDetails
              className={styles.fhirDetails}
              patient={primaryRecords.find(
                pr =>
                  `${pr.id}+${pr.meta.source}` === selectedRecord.original.id
              )}
              oncRecordOverrideIconClick={detailsMap => {
                const record = primaryRecords.find(
                  record =>
                    `${record.id}+${record.meta.source}` ===
                    selectedRecord.original.id
                );
                setRecordOverrideDialogContent(detailsMap);
                setRecordOverride(record);
                if (detailsMap.reviewOverrideType !== "all") {
                  setRecordOverrideDialog(
                    detailsMap["Mark as"] !== "Replace" ||
                      detailsMap["Mark as"] !== "New" ||
                      detailsMap.overrideIconClicked
                  );
                }
              }}
              isNewQuarantine={isNewQuarantine}
              isMultipleAttributeOverride={true}
              setAttributeOverrides={setAttributeOverrides}
              attributeOverrides={attributeOverrides}
            />
          ) : null}
          <br />
          <div className={styles.cancelButton}>
            <Button onClick={() => handleCancel()}>Cancel</Button>
          </div>
          <div className={styles.overrideButtons}>
            <Button
              primary
              className={styles.button}
              onClick={() => handleConfirm()}
              disabled={Object.values(attributeOverrides).every(a =>
                _.isEmpty(a)
              )}
            >
              Proceed to Summary
            </Button>
            <Button
              className={styles.button}
              onClick={() =>
                setAttributeOverrides(defaultAttributeOverridesObject)
              }
            >
              Reset Selections
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
};

export default MultipleAttributeOverrideModal;
